import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="container-bcs py-32 text-center" data-testid="not-found-page">
      <p className="eyebrow">404</p>
      <h1 className="mt-3 heading-lg">Page not found</h1>
      <p className="mt-4 text-ink-soft">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className="btn-primary mt-8 inline-flex">
        Back to home
      </Link>
    </div>
  );
}
